"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordCameraSubjectChanged = exports.recordCameraSubjectChangeAborted = exports.recordCameraSubjectChangeRejected = exports.recordCameraSubjectChangeRequested = exports.recordMicrophoneStatusSet = exports.recordCameraStatusSet = exports.recordWebRTCStats = exports.recordPermissionRequested = exports.attemptPermissionRequest = exports.recordInviteCreated = exports.recordIdentifyAttempted = exports.recordNoteSaved = exports.recordAppForegrounded = exports.recordAppBackgrounded = exports.recordTooltipViewed = exports.recordElementClicked = exports.recordLoggedOut = exports.recordScreenViewed = exports.recordNoteDeleted = exports.recordArtifactViewed = exports.recordArtifactDeleted = exports.recordLoginAttempted = exports.recordResolutionChanged = exports.recordArtifactUpdated = exports.recordArtifactFulfilled = exports.recordArtifactCaptured = exports.recordArtifactRequestRejected = exports.recordToolRemoved = exports.recordToolMoved = exports.recordToolPlaced = exports.recordArtifactRequested = exports.recordCallLogFavoriteUpdated = exports.recordConnectionStatusChanged = exports.recordEvent = void 0;
const api_1 = require("@streem/api");
const analytics_1 = __importDefault(require("../analytics"));
const permission_state_1 = require("./permission_state");
function recordEvent(event) {
    analytics_1.default.recordEvent(event);
}
exports.recordEvent = recordEvent;
// Emitted by both clients when their connection status changes (method or strength)
// Currently, new_strength is modeled by Twilio's NetworkQuality API
// https://www.twilio.com/docs/video/using-network-quality-api
function recordConnectionStatusChanged(roomSid, newStrength, method) {
    const event = {
        connectionStatusChanged: {
            roomSid,
            newStrength,
            method: api_1.StreemApiAnalyticEventConnectionStatusChangedMethod[method],
        },
    };
    recordEvent(event);
}
exports.recordConnectionStatusChanged = recordConnectionStatusChanged;
function recordCallLogFavoriteUpdated(status) {
    const event = {
        favoriteUpdated: {
            status,
        },
    };
    // @ts-ignore
    recordEvent(event);
}
exports.recordCallLogFavoriteUpdated = recordCallLogFavoriteUpdated;
// Emitted when an expert requests an artifact from the customer
function recordArtifactRequested(artifactId) {
    const event = {
        artifactRequested: {
            artifact: {
                artifactSid: artifactId,
            },
        },
    };
    recordEvent(event);
}
exports.recordArtifactRequested = recordArtifactRequested;
// Emitted by the tool driver (expert) when they use a tool
// For AR tools, this is when they place the tool in the 3D world
// For Non-AR tools, this is when they complete their interaction (i.e. lift their finger)
// TODO: no 'text' or 'model3d' tools implemented yet (just 'laser', 'draw', 'arrow', and 'measure')
function recordToolPlaced(eventProperties) {
    const event = {
        toolPlaced: eventProperties,
    };
    recordEvent(event);
}
exports.recordToolPlaced = recordToolPlaced;
// Emitted by the tool driver (expert) when they move an AR tool
// TODO: new story (@Adam) -- add analytics to arrow AR tools
function recordToolMoved(eventProperties) {
    const event = {
        toolMoved: eventProperties,
    };
    recordEvent(event);
}
exports.recordToolMoved = recordToolMoved;
// Emitted by the tool driver (expert) when they delete an AR tool
function recordToolRemoved(eventProperties) {
    const event = {
        toolRemoved: eventProperties,
    };
    recordEvent(event);
}
exports.recordToolRemoved = recordToolRemoved;
// TODO: cannot implement yet -- 'reject', 'capture', 'fulfilled' are customer-facing and have not yet been addressed in SDK
// Emitted when the customer rejects the expert's artifact request
function recordArtifactRequestRejected(event) {
    recordEvent(event);
}
exports.recordArtifactRequestRejected = recordArtifactRequestRejected;
// Emitted when a user successfully captures (data on device) an artifact
function recordArtifactCaptured(event) {
    recordEvent(event);
}
exports.recordArtifactCaptured = recordArtifactCaptured;
// Emitted when a user successfully fulfills (upload finishes) an artifact
function recordArtifactFulfilled(artifactId) {
    const event = {
        artifactFulfilled: {
            artifact: {
                artifactSid: artifactId,
            },
        },
    };
    recordEvent(event);
}
exports.recordArtifactFulfilled = recordArtifactFulfilled;
// Emitted when a user updates an artifact
// Ex: editing a 3d-streemshot, adding a measurement to a mesh, etc.
function recordArtifactUpdated(artifactId) {
    const event = {
        artifactUpdated: {
            artifact: {
                artifactSid: artifactId,
            },
        },
    };
    recordEvent(event);
}
exports.recordArtifactUpdated = recordArtifactUpdated;
// Emitted by both clients when their sent/received resolution changes
// Note: an orientation change is considered a resolution change, even if always-upright frames are sent.
// TODO: cannot yet implement -- we don't keep track of the video resolution yet (customer facing)
function recordResolutionChanged(roomSid, size) {
    const event = {
        resolutionChanged: {
            roomSid,
            size,
        },
    };
    recordEvent(event);
}
exports.recordResolutionChanged = recordResolutionChanged;
// Emitted when a user attempts to authenticate themselves to Streem through a first-party pipeline
// These methods attempt to exchange user knowledge (user/pass, invitation id, etc.) for a SDK token
function recordLoginAttempted(method, successful, inviteSid) {
    const event = {
        loginAttempted: {
            method: api_1.StreemApiAnalyticEventLoginAttemptedMethod[method],
            successful,
            inviteSid,
        },
    };
    recordEvent(event);
}
exports.recordLoginAttempted = recordLoginAttempted;
// Emitted when a user deletes an artifact
function recordArtifactDeleted(artifact) {
    const event = {
        artifactDeleted: {
            artifact,
        },
    };
    recordEvent(event);
}
exports.recordArtifactDeleted = recordArtifactDeleted;
// Emitted when a user views an artifact
// For artifacts like recordings, this is emitted when the user clicks play (not on page load)
function recordArtifactViewed(artifact) {
    const event = {
        artifactViewed: {
            artifact,
        },
    };
    recordEvent(event);
}
exports.recordArtifactViewed = recordArtifactViewed;
function recordNoteDeleted() {
    recordEvent({
        noteDeleted: {},
    });
}
exports.recordNoteDeleted = recordNoteDeleted;
function recordScreenViewed(screenId) {
    const event = {
        screenViewed: {
            screenId,
        },
    };
    recordEvent(event);
}
exports.recordScreenViewed = recordScreenViewed;
function recordLoggedOut() {
    const event = {
        loggedOut: {},
    };
    recordEvent(event);
}
exports.recordLoggedOut = recordLoggedOut;
// Emitted when a user interacts with an element we want to keep track of interactions with
// Ex: Clicking "Invite to Streem" would emit this event with a unique id
function recordElementClicked(elementId) {
    const event = {
        elementClicked: {
            elementId,
        },
    };
    recordEvent(event);
}
exports.recordElementClicked = recordElementClicked;
// Emmitted when a tooltip we want to keep track of is displayed to a user
// Ex. When a user views more details about their network connectivity score during a call
// by hovering over the network signal level icon
function recordTooltipViewed(tooltipId) {
    const event = {
        tooltipViewed: {
            tooltipId,
        },
    };
    recordEvent(event);
}
exports.recordTooltipViewed = recordTooltipViewed;
// For web apps, this is when they navigate to another tab or window
function recordAppBackgrounded() {
    const event = {
        appBackgrounded: {},
    };
    recordEvent(event);
}
exports.recordAppBackgrounded = recordAppBackgrounded;
// For web apps, this is when they navigate to the tab with Streem
function recordAppForegrounded() {
    const event = {
        appForegrounded: {},
    };
    recordEvent(event);
}
exports.recordAppForegrounded = recordAppForegrounded;
function recordNoteSaved(charCount, scopeSid) {
    const event = {
        noteSaved: {
            charCount,
            scopeSid,
        },
    };
    recordEvent(event);
}
exports.recordNoteSaved = recordNoteSaved;
// Emitted when a user attempts to exchange a SDK token for an access token (/auth/token)
// The SDK token can be provided by means a Login event or by means of a third-party outside the realm of Streem
// TODO: implement in web/packages/auth/src/managers/access_token_manager.ts
function recordIdentifyAttempted(successful, groupReservationSid) {
    const event = {
        identifyAttempted: {
            successful,
            groupReservationSid,
        },
    };
    recordEvent(event);
}
exports.recordIdentifyAttempted = recordIdentifyAttempted;
// Emitted when a user attempts to invite another user to a Streem by creating an invitation
function recordInviteCreated(inviteSid, method) {
    const event = {
        inviteCreated: {
            inviteSid,
            method: api_1.StreemApiAnalyticEventInviteCreatedMethod[method],
        },
    };
    recordEvent(event);
}
exports.recordInviteCreated = recordInviteCreated;
function attemptPermissionRequest(permission, request, onRequestError) {
    return __awaiter(this, void 0, void 0, function* () {
        const usePermissionsApi = 'permissions' in navigator;
        const { result, requested, granted } = usePermissionsApi
            ? yield attemptPermissionApiRequest(permission, request, onRequestError)
            : yield attemptPermissionTimingRequest(request, onRequestError);
        recordPermissionRequested(permission, granted, !!requested);
        return result;
    });
}
exports.attemptPermissionRequest = attemptPermissionRequest;
/**
 * Use Permissions API for exact results on if permission was requested or not.
 * @see {@link https://caniuse.com/permissions-api} for current browser support
 */
function attemptPermissionApiRequest(permission, request, onRequestError) {
    return __awaiter(this, void 0, void 0, function* () {
        let result;
        let error;
        let requested;
        try {
            requested = yield (0, permission_state_1.willPromptForPermission)(permission);
        }
        catch (e) {
            requested = false;
            error = e;
        }
        // Perform the actual request
        try {
            result = yield request();
        }
        catch (e) {
            onRequestError(e);
        }
        // In certain situations, the browser will report that the permission has been granted when it actually hasn't
        // Ex: the browser has been denied permissions from the OS
        let granted;
        if (error === null || error === void 0 ? void 0 : error.message.includes('Permission denied')) {
            granted = false;
        }
        else {
            try {
                granted = yield (0, permission_state_1.hasPermission)(permission);
            }
            catch (error) {
                granted = false;
            }
        }
        return {
            result,
            requested,
            granted,
        };
    });
}
/**
 * Use timings and errors to determine whether or not permission was requested or not
 */
function attemptPermissionTimingRequest(request, onRequestError) {
    return __awaiter(this, void 0, void 0, function* () {
        let result;
        let requested;
        let granted;
        const startTime = new Date().getTime();
        try {
            result = yield request();
            granted = true;
        }
        catch (e) {
            onRequestError(e);
            granted = false;
        }
        const endTime = new Date().getTime();
        if (endTime - startTime > 1000) {
            requested = true;
        }
        return {
            result,
            requested,
            granted,
        };
    });
}
function recordPermissionRequested(permission, granted, promptShown) {
    var _a, _b;
    const event = {
        permissionRequested: {
            permission: api_1.StreemApiAnalyticEventPermissionRequestedPermission[permission],
            inviteSid: (_a = analytics_1.default._inviteId) === null || _a === void 0 ? void 0 : _a.toString(),
            groupReservationSid: (_b = analytics_1.default._groupReservationId) === null || _b === void 0 ? void 0 : _b.toString(),
            granted,
            promptShown,
        },
    };
    recordEvent(event);
}
exports.recordPermissionRequested = recordPermissionRequested;
function recordWebRTCStats(roomSid, { localVideo = [], localAudio = [], remoteVideo = [], remoteAudio = [] }) {
    localVideo.forEach(stats => {
        stats.roomSid = roomSid;
        recordEvent({
            // @ts-ignore
            localVideoStatsMeasured: stats,
        });
    });
    localAudio.forEach(stats => {
        stats.roomSid = roomSid;
        recordEvent({
            // @ts-ignore
            localAudioStatsMeasured: stats,
        });
    });
    remoteVideo.forEach(stats => {
        stats.roomSid = roomSid;
        recordEvent({
            // @ts-ignore
            remoteVideoStatsMeasured: stats,
        });
    });
    remoteAudio.forEach(stats => {
        stats.roomSid = roomSid;
        recordEvent({
            // @ts-ignore
            remoteAudioStatsMeasured: stats,
        });
    });
}
exports.recordWebRTCStats = recordWebRTCStats;
function recordCameraStatusSet(enabled, roomId) {
    const event = {
        cameraStatusSet: {
            roomSid: roomId.toString(),
            enabled,
        },
    };
    recordEvent(event);
}
exports.recordCameraStatusSet = recordCameraStatusSet;
function recordMicrophoneStatusSet(enabled, roomId) {
    const event = {
        microphoneStatusSet: {
            roomSid: roomId.toString(),
            enabled,
        },
    };
    recordEvent(event);
}
exports.recordMicrophoneStatusSet = recordMicrophoneStatusSet;
function recordCameraSubjectChangeRequested(roomId, toSubject) {
    const event = {
        cameraSubjectChangeRequested: {
            roomSid: roomId.toString(),
            toSubject: api_1.StreemApiAnalyticEventCameraSubjectChangeRequestedToSubject[toSubject],
        },
    };
    recordEvent(event);
}
exports.recordCameraSubjectChangeRequested = recordCameraSubjectChangeRequested;
function recordCameraSubjectChangeRejected(roomId) {
    const event = {
        cameraSubjectChangeRejected: {
            roomSid: roomId.toString(),
        },
    };
    recordEvent(event);
}
exports.recordCameraSubjectChangeRejected = recordCameraSubjectChangeRejected;
function recordCameraSubjectChangeAborted(roomId) {
    const event = {
        cameraSubjectChangeAborted: {
            roomSid: roomId.toString(),
        },
    };
    recordEvent(event);
}
exports.recordCameraSubjectChangeAborted = recordCameraSubjectChangeAborted;
function recordCameraSubjectChanged(roomId, subject) {
    const event = {
        cameraSubjectSet: {
            roomSid: roomId.toString(),
            subject: api_1.StreemApiAnalyticEventCameraSubjectSetSubject[subject],
        },
    };
    recordEvent(event);
}
exports.recordCameraSubjectChanged = recordCameraSubjectChanged;
//# sourceMappingURL=event_helpers.js.map